export default __webpack_public_path__ + "static/media/title.8d1f067e.svg";